import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Renders its children into the shared #approval-col-cfg slot in the Approvals
 * tab bar, but ONLY when `active` (this tab is the selected one). This lets each
 * tab's "Configure Column" button appear on the tab-bar line (left of the info
 * icon) without every mounted-but-hidden tab pane rendering its button too.
 */
const ColConfigPortal = ({ active, children }) => {
  const [target, setTarget] = useState(null);

  useEffect(() => {
    if (!active) {
      setTarget(null);
      return;
    }
    // The slot lives in the parent tab bar; grab it after this tab activates.
    setTarget(document.getElementById('approval-col-cfg'));
  }, [active]);

  if (!active || !target) return null;
  return createPortal(children, target);
};

export default ColConfigPortal;
